import { purify } from "../../js/lib/escape.js";
const location = "plugins/iconset/live/icons/";
const sheet = new CSSStyleSheet();
// 2. Populate the sheet content (e.g., in the component's constructor)
sheet.replaceSync(`
  .g-default,
  .stroke {
    fill: none;
    stroke: var(--icon-main, #000);
    stroke-miterlimit: 10;
    stroke-width: 1.6px;
  }
  .stroke-custom {
    stroke: var(--icon-stroke-color, var(--icon-main));
  }
  .stroke-thick {
    stroke-width: 2px;
    stroke-linecap:round;
  }
  .stroke-thinner {
    stroke-width: 1.4px;
  }
  .stroke-thinnest {
    stroke-width: 0.2px;
  }
  .stroke-narrow {
    stroke-width: 1.24556732px;
  }
  .stroke-red {
      stroke: #ef513c;
  }
  .circle {
    stroke: var(--icon-dyn-border-clr, none);
    stroke-width: 1px;
    fill: var(--icon-dyn-bg, none);
    transition: all 132ms;
  }
  .transparent {
    fill: var(--icon-dyn-bg, transparent);
  }
  .fill {
    fill: var(--icon-main, #172a64);
  }
  .no-stroke {
    stroke: none;
  }
  .pull-hover {
    transition: transform 200ms;
    transform: translateY(var(--pull-hover-delta, 0));
  }
  .g-flip {
    transform: scale(1, -1) translateY(-100%);
  }
  .g-rotate {
    transform-origin: center;
    transform: rotate(180deg);
  }
  .hacks-f {
    transform: translateX(-1px);
  }
  .hacks-block-start {
    transform: translateY(-6px);
  }
  .hacks-block-end {
    transform-origin: 50% 50%;
    transform: rotate(180deg) translateY(-6px);
  }
  .new {
    stroke: var(--icon-new, #6ab559);
  }
  .badge {
    stroke: var(--icon-badge-info, #6ab559);
  }
  .fore-fill {
    fill: var(--icon-main-fore, #fff);
  }
  .fore-stroke {
    stroke: var(--icon-main-fore, #586e76);
  }
  .careful-stroke {
    stroke: var(--icon-careful-clr, #ef513c);
  }
  .insert-stroke1 {
    stroke: var(--action-insert-fg, #6ab559);
  }
  .insert-circle1 {
      stroke: var(--action-insert-border-clr, none);
      stroke-width: 3px;
      fill: var(--action-insert-bg);
  }
  .insert-bg1 {
      fill: var(--action-insert-bg);
  }
  .num1 {
    font-size: 9.79px;
    font-family: Segoe UI;
    font-weight: 700;
  }
  .checkout-arrow1 {
    transform: translateX(var(--icon-translate-0-x, 0));
    transition: transform 120ms;
  }
  .pull1 {
    transition: transform 200ms;
    transform: translateY(var(--pull-hover-delta, 0));
  }
  .arrow1 {
    stroke: #6ab559;
  }
  @keyframes loading {
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
  }
  .rotating {
    transform-origin: center;
    animation: var(--loading-animation) 1.3s linear var(--loading-cycles, infinite);
  }
      .border1 {
        transition: fill 132ms;
      }

`);

const map = {
  "archive": "archive",
  "cut": "content_cut_black_24dp",
  "cloud-unknown--large": "cloud-unknown",
  "search-result-node": "node",
  "search-result-label": "text",
  "search-result-data": "variable",
  "jumplist": "jumplist",
  "jump": "jump",
  "jump-from": "jump-from",
  "jump-to": "jump-to",
  "search-result-jumplist": "jumplist",
  "search-result-assignment": "formula",
  // "search-result-yellownote": "yellownote",
  "search-result-informationsource": "info",
  // "search-result-informationsourcenode": "informationsourcenode",
  "search-result-edge": "connect-node",
  "search-result-input": "question",
  // "search-result-hint": "hint",
  "search-result-linklabel": "link",
  // "search-result-midescription": "midescription",
  // "search-result-sql": "sql",
  // "search-result-workflowdescription": "workflowdescription",
  // "search-result-workflowstepcode": "workflowstepcode",
  // "search-result-workflowedgecode": "workflowedgecode",
  "search-result-textfragment": "textfragment",
  "search-result-title": "text-header",
  "search-result-source": "source",
  "source": "source",
  "XML interface": "externaldata",
  "aansluitpunt": "aansluitpunt",
  "account": "account_circle",
  "action": "settings",
  "action_insert": "action--insert",
  "action_insert--round": "action_insert--round",
  "add node": "addnode",
  "add": "add",
  "add--large": "add--large",
  "attachment": "attachment",
  "autofit": "autofit",
  "back--large": "back--large",
  "block": "block--start",
  "entire-block": "block",
  "close": "close",
  "close-no-circle": "close-no-circle",
  "toc": "toc_black_24dp",
  "center-focus-extra-weak": "center_focus_extra_weak",
  "center-focus-strong": "center_focus_strong",
  "drag-indicator--large": "drag-indicator",
  "end block": "block--end",
  "call graph": "callgraph",
  "call library": "library",
  "checkbox": "addcheckbox",
  "checklist": "checklist",
  "checkmultilist": "checklist",
  "conclusion": "text",
  "circle": "circle",
  "circle--filled": "circle--filled",
  "combobox": "dropdown",
  "comment": "comment_black_24dp",
  "convert": "forceopenandsave",
  "clipboard": "logdatamodel",
  "create dataset": "createdataset",
  "curl": "curl",
  "database": "database", // Dunno, Studio does funny too..
  "dataset": "createdataset",
  "date": "adddate",
  "datetime": "adddate",
  "clear--large": "delete--large",
  "delete textfragment": "textfragment", // Actually not, but ok for now
  "delete_forever": "delete_forever2",
  "difference": "difference",
  "disconnect": "disconnect",
  "document link": "linktodocument",
  "document": "document",
  "dot--complete": "dot--complete",
  "dot--current": "dot--current",
  "dot--incomplete": "dot--incomplete",
  "dot--next-step": "dot--next-step",
  "duplicate": "content_copy2",
  "edit": "edit",
  "edit--large": "edit--large",
  "edit_on": "edit_on",
  "edit_off": "edit_off",
  "email": "email",
  "empty": "empty",
  "export": "export",
  "externaldata": "database", // Dunno, Studio does funny too..
  "favorite": "favorite",
  "firstpage": "firstpage",
  "history": "history",
  "keyboard": "keyboard_black",
  "navigator": "datanavigation",
  "fixed": "database", // Dunno, Studio does funny too..
  "formula": "formula",
  "formula:dataset": "formula-dataset",
  "textformula": "formula",
  "memo": "textfragment",
  "mis--large": "mis--large",
  "function": "formula",
  "function-category": "formula",
  "generate document": "document",
  "generate text": "settings", // Why? Because it's an action?
  "goto": "connect-node",
  "node:parent": "parent-node",
  "node:current": "node--current",
  "goto:normal": "connect-node",
  "goto:runtonode": "jumplist",
  "goto:exit": "exit",
  "graph": "callgraph",
  "graph-category": "callgraph",
  "graph--large": "graph--large",
  "grid": "table",
  "hamburger": "hamburger",
  "help": "help",
  "home": "home",
  "home--large": "home--large",
  "import": "import",
  "importXML": "importxml",
  "info": "info",
  "input checkbox": "checkbox3",
  "input radio": "radio2",
  "lastpage": "lastpage",
  "library": "library",
  "linked label": "link",
  "link": "link",
  "list--add": "list--add",
  "listlabel": "listlabel",
  "location-pin": "location-pin",
  "logout": "checkout",
  "markdown": "markdown",
  "more": "more--v2",
  "move--horizontally": "move--horizontally",
  "move--left": "move--left",
  "move--right": "move--right",
  "move--down": "move--down",
  "move--up": "move--up",
  "new node": "node",
  "node": "node",
  "node-category": "node",
  "picture": "addpicture",
  "picture fragment": "picout",
  "settings": "settings",
  "settings--large": "settings--large",
  "split--left": "split--left",
  "split--right": "split--right",
  "split--down": "split--down",
  "split--up": "split--up",
  "move--vertically": "move--vertically",
  "new graph": "newgraph",
  "new model": "newmodel",
  "new-model--large": "new-model--large",
  "number": "addnumber",
  "numedit": "addnumber",
  "open": "open",
  "pin": "pin-beta-1",
  "publish": "publish",
  "pull": "pull",
  "pull--large": "pull--large",
  "combo-button-pull": "combo-button-pull",
  "pause": "pause",
  "play": "play",
  "prettyprint": "prettyprint",
  "quickstart": "quickstart",
  "question": "question-with-mark",
  "equation": "question",
  "radiogroup": "setvalue",
  "redo": "redo",
  "refresh": "refresh-animated",
  "rename": "rename02",
  "repeat": "repeat",
  "restore-from-trash": "restore-from-trash",
  "re-arrange--large": "re-arrange--large",
  "run": "run",
  "save": "save",
  "search": "search",
  "table": "table",
  "textfragment": "textfragment",
  "themeday": "themeday",
  "themenight": "themenight",
  "timeline--current": "timeline--current",
  "title": "text-header",
  "to-production": "to-production",
  "tune": "tune-beta-1",
  "variable": "variable",
  "variable-category": "variable",
  "view": "datanavigation",
  "undo": "undo-upper",
  "until": "next",
  "viewCompact": "viewcompact",
  "text": "text",
  "expand--less": "expand--less",
  "expand--more": "expand--more",
  "unfold--less": "unfold--less",
  "unfold--more": "unfold--more",
  "templateslist--large": "templateslist--large",
  "copy-circlede": "content_copy2",
  "copy-circled": "copy-to-clipboard",
  "copy": "copy-to-clipboard-no-circle",
  "replace": "swap_vert_black_24dp",
  "replace-horizontal": "replace-horizontal",
  "analysis": "eye",
  "screenmode--clear": "screenmodeclear",
  "screenmode--addbottom": "screenmodeaddbottom",
  "screenmode--addtop": "screenmodeaddtop",
  "makenodefirst": "acmakenodefirst",
  "removed--large": "removed--large",
  "warning": "warning",
  "thumb-up-alt": "thumb_up_alt"
};

const src = key => `${location}${map[key]}.svg?v=2`;

export { map, src };

const IconCache = new Map();

const setTitle = icon => {
  let elt = icon.shadowRoot.querySelector("title");
  let name = icon.title;
  if (!name && elt) elt.remove();
  if (name && elt) elt.textContent = name;
  if (name && !elt) {
    let svg = icon.shadowRoot.querySelector("svg");
    if (!svg) return;
    else {
      let title = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "title"
      );
      title.textContent = name;
      svg.appendChild(title);
    }
  }
};

const setViewBox = ({ icon, viewBox }) => {
  let svg = icon.shadowRoot.querySelector("svg");
  if (!svg) return;
  svg.setAttribute("viewBox", viewBox);
};

const missingIcons = {};

class Icon extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    // 3. Apply the sheet to the Shadow Root
    this.shadowRoot.adoptedStyleSheets = [sheet];
  }
  static get observedAttributes() {
    return ["shape", "alt", "viewbox"];
  }
  set title(value) {
    this.setAttribute("alt", value);
  }
  get title() {
    return this.getAttribute("alt");
  }
  async attributeChangedCallback(name, oldVal, newVal) {
    if (name === "shape") {
      if (!map[newVal]) {
        this.dataset["missing"] = true;
        if (!missingIcons[newVal]) {
          console.warn(`No icon file defined for shape "${newVal}"`);
          missingIcons[newVal] = true;
        }
        this.shadowRoot.replaceChildren();
        return;
      }
      delete this.dataset["missing"];
      const resource = src(newVal);
      IconCache.set(
        resource,
        IconCache.get(resource) ||
          fetch(resource)
            .then(res => res.text())
            .then(html => {
              const f = document.createElement("div");
              f.innerHTML = purify(html);
              return f;
            })
      );
      const iconData = await IconCache.get(resource);
      this.shadowRoot.replaceChildren(...iconData.cloneNode(true).children);

      setTitle(this, this.title);
      if (this.getAttribute("viewbox")) {
        setViewBox({ icon: this, viewBox: this.getAttribute("viewbox") });
      }
    }
    if (name === "alt") {
      setTitle(this, this.title);
    }
    if (name === "viewbox") {
      setViewBox({ icon: this, viewBox: this.getAttribute("viewbox") });
    }
  }
}

customElements.define("bb-icon", Icon);
